// removed by extract-text-webpack-plugin
module.exports = {"budgetContainer":"budgetContainer_Y8M","budgetContainerHeading":"budgetContainerHeading_3jN","opacityIn":"opacityIn_3hH","budgetContainerHeadingSub":"budgetContainerHeadingSub_1aS","headingLeaving":"headingLeaving_1AY","opacityOut":"opacityOut_3M2","bubbleContainer":"bubbleContainer_21N","backgroundFadeIn":"backgroundFadeIn_2_Q","bubbleContainerLeaving":"bubbleContainerLeaving_1qf","backgroundFadeOut":"backgroundFadeOut_3yl","scaleIn":"scaleIn_dqp","scaleOut":"scaleOut_1vO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/budget-container/budget-container.scss
// module id = 640
// module chunks = 0 1